import { patientActions, noteActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [noteActions.startNoteEvalOptions]: (state, action) => {
        return { ...state, ...action.payload.response.entities.prepopulateEvals };
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if( x.ptno === action.payload ) {
                delete state[x.id];
            }
        })
    },
    [noteActions.startNoteEvalOptionsClear]: (state, action) => {
        return Object.values(state).forEach(x => {
            if( x.epno === action.payload.epno ) {
                delete state[x.id];
            }
        })
    },
    [noteActions.startBlankEvalSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if( x.epno === action.payload.epno ) {
                delete state[x.id];
            }
        })
    },
    [noteActions.transferEvalSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if( x.epno === action.payload.epno ) {
                delete state[x.id];
            }
        })
    },
    [noteActions.prepopulateEvalSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if( x.epno === action.payload.epno ) {
                delete state[x.id];
            }
        })
    },

})


